import { useMutation } from '@zg-rentals/react-query5';
import { useDispatch } from 'react-redux';
import { declineApplication } from '../api';

export default function useDeclineApplication(useMutationOptions) {
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: async (requestBody) => {
      try {
        // this next line throws exception for any non-200 response, hence the try/catch
        const response = await dispatch(declineApplication(requestBody));

        if (response.data.success) {
          return Promise.resolve(response);
        }

        return Promise.reject(response);
      } catch (e) {
        return Promise.reject(e?.response);
      }
    },
    ...useMutationOptions,
  });
}
